export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f54c17b4b5acdd1d31e6d43c28a1a76b1db323cb3&name=fetchTypeahead!'